export const PROFILES = [

  {
      id:"athlete",
      label:"profile.athlete"
  },

  {
      id:"club",
      label:"profile.club"
  },

  {
      id:"staff",
      label:"profile.staff"
  },

  {
      id:"lawyer",
      label:"profile.lawyer"
  },

  {
      id:"media",
      label:"profile.media"
  },

  {
      id:"brand",
      label:"profile.brand"
  },

  {
      id:"fan",
      label:"profile.fan"
  }

];